export const COURSE_CONTENT_CHANGE_KEY = 'magellan:course-content:changed';
const CHANGE_EVENT = 'magellan-course-content-changed';
let sequence = 0;

// Broadcast only an invalidation marker, never course content or Admin data.
export function notifyCourseContentChanged() {
  try { window.localStorage.setItem(COURSE_CONTENT_CHANGE_KEY, `${Date.now()}:${sequence++}`); }
  catch { /* Returning to a course tab still refreshes it. */ }
  window.dispatchEvent(new Event(CHANGE_EVENT));
}

export function watchCourseContentChanges(refresh) {
  const visible = () => { if (document.visibilityState !== 'hidden') refresh(); };
  const storage = event => { if (event.key === COURSE_CONTENT_CHANGE_KEY) visible(); };
  window.addEventListener('focus', visible);
  document.addEventListener('visibilitychange', visible);
  window.addEventListener('storage', storage);
  window.addEventListener(CHANGE_EVENT, visible);
  return () => {
    window.removeEventListener('focus', visible);
    document.removeEventListener('visibilitychange', visible);
    window.removeEventListener('storage', storage);
    window.removeEventListener(CHANGE_EVENT, visible);
  };
}
